module.exports = __webpack_public_path__ + "img/365.9b41094c.svg";